import { isNil } from 'lodash';
import { convertMoneyToNumber } from './currency';
import { calculateMinimumPrice, getRecommendedPrice } from './pricing';
import { Conditions } from '../shopConfig/filters/condition';
import { PricingRestriction } from '../types/shopConfig/shopConfigV2';
import { Money as MoneyType } from '../types/sharetribe/money';

interface GetRecommendedPriceForConditionParams {
  price: MoneyType;
  condition: Conditions;
  conditionToRecommendedDiscount: { [condition in Conditions]: number };
  pricingRestrictions: PricingRestriction[];
  tags: string[] | null;
  category?: string;
  resaleValueConfig?: { [key: string]: string };
}

export const getRecommendedPriceForCondition = ({
  price,
  condition,
  conditionToRecommendedDiscount,
  pricingRestrictions,
  tags,
  category,
  resaleValueConfig,
}: GetRecommendedPriceForConditionParams): number => {
  if (!price || isNil(price.amount)) {
    return 0;
  }
  const priceValue = convertMoneyToNumber(price);
  const calculatedMinimumPrice = calculateMinimumPrice(priceValue, pricingRestrictions, tags);

  const recommendedPrice = Math.max(
    getRecommendedPrice({
      price: priceValue,
      condition,
      conditionToRecommendedDiscount,
      category,
      productTags: tags,
      resaleValueConfig,
    }),
    calculatedMinimumPrice / 100
  );

  return Number(recommendedPrice.toFixed(2));
};
